// ViewExplanation.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewExplanation.css";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
const API_BASE = "https://rsa.feetracer.in/app";
const GET_EXPLANATION_ENDPOINT = `${API_BASE}/get_explanation.php`;

function optionIndexToLetter(i) {
  return String.fromCharCode(65 + i);
}

const ViewExplanation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [payload, setPayload] = useState(null);

  // =====================================
  // ⭐ LOGIN CHECK + SAVE REDIRECT
  // =====================================
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user || !user.id) {
      // Save redirect path so after login user goes to mocktest
      sessionStorage.setItem("redirect_after_login", "/mocktest");

      Swal.fire("Not Logged In", "Please login first", "warning").then(() => {
        navigate("/login");
      });
      return;
    }
  }, [navigate]);

  // =====================================
  // ⭐ FETCH EXPLANATION DATA
  // =====================================
  useEffect(() => {
    if (!id) {
      setError("Missing exam id in URL");
      setLoading(false);
      return;
    }

    const url = `${GET_EXPLANATION_ENDPOINT}?id=${encodeURIComponent(id)}`;
    console.log("[ViewExplanation] fetching:", url);

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const trimmed = text.trim();
        if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
          console.error("Non-JSON response:", trimmed.slice(0, 500));
          throw new Error("Server returned invalid response");
        }
        return JSON.parse(trimmed);
      })
      .then((data) => {
        if (!data.success) throw new Error(data.message || "API error");
        setPayload(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  // UI states
  if (loading) return <div className="loading">Loading explanations...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  if (!payload) return <div className="error">No data available</div>;

  const { exam_meta, counts, questions } = payload;

  // =====================================
  // ⭐ EXAM TITLE LOGIC
  // =====================================
  const examType = exam_meta.exam_type; // "M" or "C"
  const subject = exam_meta.subject_name || "Subject";
  const chapter = exam_meta.chapter_name || "Chapter";

  let examTitle =
    examType === "C"
      ? `Chapter Exam – ${subject} # ${chapter}`
      : `Master Exam – ${subject}`;

  const showSkipBookmark = examType === "C";

 return (
  <section>
 <div className="row mb-4 align-to-left mt-4 ms-1">

        <div className="row">

          <div className="col-xl-12 col-lg-12 col-md-12">

            <nav aria-label="breadcrumb">

              <ol className="breadcrumb">

                <li className="breadcrumb-item text-muted">
                  <Link to="/studentdashboard">
                    Dashboard
                  </Link>
                </li>

                <li className="breadcrumb-item text-muted">
                  <Link to="/subjects">
                    Subject
                  </Link>
                </li>
 
             <li className="breadcrumb-item"><Link to="#" className="text-main">View Explaination</Link></li>
                         
              </ol>

            </nav>

          </div>

        </div>

      </div>
    <div className="explanation-section">

      {/* ========================= */}
      {/* BREADCRUMB */}
      {/* ========================= */}

     

      {/* ========================= */}
      {/* EXAM SUMMARY */}
      {/* ========================= */}

      <div className="exam-summary">

        <h2>{examTitle}</h2>

        <p>
          Exam Time :{" "}
          {exam_meta.start_time && exam_meta.end_time
            ? `${exam_meta.start_time} - ${exam_meta.end_time}`
            : exam_meta.start_time || "—"}
        </p>

        {/* COUNTS */}

        <p>
          Total: <strong>{counts.total}</strong>

          {" "} | 🟢 Correct:
          <strong> {counts.correct}</strong>

          {" "} | 🔴 Wrong:
          <strong> {counts.wrong}</strong>

          {showSkipBookmark && (
            <>
              {" "} | 🔵 Skipped:
              <strong> {counts.skipped}</strong>

              {" "} | 🟡 Bookmarked:
              <strong> {counts.bookmark}</strong>
            </>
          )}

          {" "} | ⚪ Not Attempted:
          <strong> {counts.notAttempted}</strong>
        </p>

      </div>

      {/* ========================= */}
      {/* QUESTIONS */}
      {/* ========================= */}

      <div className="questions-list">

        {questions.map((q, idx) => {

          const correctIndex = q.options.findIndex(
            (o) => o.key === q.correct_answer
          );

          const selectedIndex = q.options.findIndex(
            (o) => o.key === q.selected_option
          );

          return (

            <div
              key={q.exam_answer_id || q.question_id || idx}
              className="explanation-card"
            >

              <h3 className="question-title">
                {idx + 1}. {q.question}
              </h3>

              <div className="question-meta">
                Quiz ID:
                {" "}
                <strong>{q.quiz_id}</strong>
              </div>

              <ul className="choices-list">

                {q.options.map((opt, i) => {

                  let cls = "choice-item";

                  if (i === correctIndex)
                    cls += " correct-choice";

                  if (
                    i === selectedIndex &&
                    i !== correctIndex
                  )
                    cls += " wrong-choice";

                  if (
                    i === selectedIndex &&
                    i === correctIndex
                  )
                    cls += " user-correct-choice";

                  return (

                    <li key={opt.key} className={cls}>

                      <strong>
                        {optionIndexToLetter(i)}.
                      </strong>

                      {" "}
                      {opt.label}

                      {i === selectedIndex && (
                        <span> — your answer</span>
                      )}

                      {i === correctIndex && (
                        <span> — correct</span>
                      )}

                    </li>

                  );

                })}

              </ul>

              {q.explanation && (

                <p className="explanation-text">

                  <strong>Explanation:</strong>
                  {" "}
                  {q.explanation}

                </p>

              )}

            </div>

          );

        })}

      </div>

      {/* ========================= */}
      {/* RETRY BUTTON */}
      {/* ========================= */}

      <div className="retry-button-container">

        <button
          className="btn-outline"
          onClick={() => navigate("/subjects")}
        >
          🔄 Retry Quiz
        </button>

      </div>

    </div>

  </section>
);
};

export default ViewExplanation;
